import React from "react";

const Payment = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center">
      <div className="max-w-3xl mx-auto w-full py-8 px-4">
        <h1 className="text-4xl font-bold text-center mb-8 black">Úplata za vzdělávání</h1>

        {/* New section for payment information */}
        <div className="bg-white rounded-lg p-6 mb-8 shadow-md">
          <h2 className="text-2xl font-semibold mb-4 text-black">Ve školním roce 2025/2026 je stanovena úplata za vzdělávání v následující výši:</h2>
          <ul className="list-disc list-inside space-y-2 mb-4 text-gray-700">
            <li><strong>Hudební obor:</strong> 1 800Kč/pololetí</li>
            <li><strong>Výtvarný obor:</strong> 1 500Kč/pololetí</li>
            <li><strong>Taneční obor:</strong> 1 300Kč/pololetí</li>
          </ul>
          <p className="text-gray-700">
            Předpis pro platbu je zasílán zákonnému zástupci žáka/žákyně na emailovou adresu prostřednictvím systému klasifikace.
          </p>
        </div>
        {/* End of new section */}
      </div>
    </div>
  );
};

export default Payment;